import {alias, primitive, object, serializable} from "serializr";
import {MetaModel} from "../CourseModels/SubjectModel/subject.model";

export class InternalUserModel {
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('email', primitive()))
    email?: string;
    @serializable(alias('first_name', primitive()))
    firstName?: string;
    @serializable(alias('last_name', primitive()))
    lastName?: string;
    @serializable(alias('phone_number', primitive()))
    phoneNumber?: string;
    @serializable(alias('full_name', primitive()))
    fullName?: string;
    @serializable(alias('display_picture_url', primitive()))
    displayPictureUrl?: string;
    @serializable(alias('role_name', primitive()))
    roleName?: string;
    @serializable(alias('role', object(MetaModel)))
    role?: string;
    @serializable(alias('role_id', primitive()))
    roleId?: string;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('password', primitive()))
    password?: boolean;
}
